// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import {Switch, Tree} from "antd";
import {history} from "../../configs/history";

// Import Styles
import '../../assets/styles/containerStyles/appended-product-section.scss';
import '../../assets/styles/containerStyles/product/product-add-edit.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import {InputGroup} from "../../components/uiElements/inputGroup";
import {LinkButton} from "../../components/buttons/buttons";
import {LanguageTabs} from "../../components/uiElements/Tabs";
import {Editor} from "../../components/uiElements/Editor";
import ProductCard from "../../components/cards/ProductCard";
import Nestable from "react-nestable";
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import ProductsSelectorModal from "../../components/ProductsSelectorModal";
import {MediaFileCard} from "../../components/media/MediaFileCard";


// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {
    arraysEquals,
    changeStateField,
    getInputValues,
    getPatchReqData,
    getPostReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
    toggleStateField,
} from "../../utils/helperFunctions";
import {AddProduct, AppendBrand, GetProductById, UpdateProduct,} from "../../redux/actions";
import {validateTranslations} from "../../utils/validateTranslations";
import {ACCEPT_IMAGE_TYPES} from "../../constants/acceptedTypes";
import {DEFAULT_IMAGE_ID, MEASUREMENT_TYPES, MEDIA_MODAL_TYPES} from "../../constants/constTypes";
import {MaterialIcon} from "../../components/utils/Icon";

const {TreeNode} = Tree;

const measurementUnitOptions = Object.keys(MEASUREMENT_TYPES).map(key => ({
    id: key,
    name: MEASUREMENT_TYPES[key]
}));

class AddEditProduct extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            'title',
            'subTitle',
            'description',
            'utilize',
            'ingredients',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                filters: [],               // +
                partners: [],              // +
                categories: [],            // +
                medias: [],                // +
                brand: null,               // +
                price: "",                 // +
                oldPrice: "",              // +
                count: 0, // count         // +
                bestSeller: false,         // +
                badges: [],                // +
                isHidden: false,           // +


                attributeValues: [],
                identicalProducts: [],
                measurementUnit: undefined,
                isAvailable: false,
                isSpecialOffer: false,
            },
            attributeNewValue: '',
            addAttributeKey: null,
            currentData: null,
            errors: {},
            errorsTabs: [],
            loading: false,
            requestLoading: false,
            languageTab: props.mainLanguage,
            isEditing: !!props?.id,
            mediaModalOpen: false,
            productsModalOpen: false,
        };
        this.updatedDataMap = new Map();
        this.toggleMediaModal = toggleStateField.bind(this, 'mediaModalOpen');
        this.toggleProductsModal = toggleStateField.bind(this, 'productsModalOpen');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getTranslatableInputValues = getTranslatableInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getPostReqData = getPostReqData.bind(this);
        this.onProductPositionChange = this.onProductPositionChange.bind(this);
        this.onMediaPositionChange = this.onMediaPositionChange.bind(this);
        this.checkProductListDifferent = this.checkProductListDifferent.bind(this);
        this.checkMediaListDifferent = this.checkMediaListDifferent.bind(this);
        this.productCardWrapper = this.productCardWrapper.bind(this);
        this.mediaCardWrapper = this.mediaCardWrapper.bind(this);
        this.getProducts = this.getProducts.bind(this);
        this.deleteProduct = this.deleteProduct.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.deletePartners = this.deletePartners.bind(this);
        this.addUpdateProduct = this.addUpdateProduct.bind(this);
        this.addPartnerItem = this.addPartnerItem.bind(this);
    }

    async componentDidMount() {
        const {isEditing, fieldsData} = this.state;

        if (isEditing) {
            const {id, brands, filtersList, attributesList} = this.props;
            await this.props.GetProductById(id);
            const {productById} = this.props;
            if (!productById) {
                history.push('/products');
                return;
            }

            // Translations
            const translationsData = {};
            Object.keys(fieldsData.translations).forEach(key => {
                const trItem = productById.translations.find(item => item.language === key);
                translationsData[key] = {
                    title: trItem?.title || '',
                    subTitle: trItem?.subTitle || '',
                    description: trItem?.description || '',
                    utilize: trItem?.utilize || '',
                    ingredients: trItem?.ingredients || '',
                };
            });

            /*            //Filter ids
                        const filters = [];
                        productById.filters && productById.filters.forEach(filter => {
                            // filters.push(filter.id);
                            const correspondingFilter = filtersList.find(f => f.id === filter.id);
                            let allValuesChecked = true;

                            correspondingFilter.values.forEach(v => {
                                if (!filter?.values?.some(value => value.id === v.id)) {
                                    allValuesChecked = false;
                                }
                            })
                            filter.values && filter.values.forEach(value => {
                                filters.push(value.id);
                            });
                            allValuesChecked && filters.push(filter.id);
                        });

                        //Attribute ids
                        const attributeValues = [];
                        productById.attributes && productById.attributes.forEach(attribute => {
                            // attributeValues.push(attribute.id);
                            const correspondingAttribute = attributesList.find(f => f.id === attribute.id);
                            let allValuesChecked = true;

                            correspondingAttribute.values.forEach(v => {
                                if (!attribute?.values?.some(value => value.id === v.id)) {
                                    allValuesChecked = false;
                                }
                            })
                            attribute.values && attribute.values.forEach(value => {
                                attributeValues.push(value.id);
                            });
                            allValuesChecked && attributeValues.push(attribute.id);
                        });*/

            //Badges -- multiSelect
            const badges = productById?.badges ? productById.badges.map(b => b.id) : [];

            //Products
            const identicalProducts = Array.isArray(productById?.identicalProducts) ?
                productById.identicalProducts : []

            if (productById?.brand && !brands?.itemsList?.find(b => b.id === productById?.brand?.id)) {
                this.props.AppendBrand(productById.brand)
            }
            //Medias
            const medias = [];
            if (Array.isArray(productById?.medias)) {
                productById.medias && productById.medias.forEach(media => {
                    media.id !== DEFAULT_IMAGE_ID && medias.push(media);
                })
            }

            const initStateData = {
                translations: translationsData,
                filters: productById.filters || [],
                partners: Array.isArray(productById.partners) ? productById.partners : [],
                categories: productById.categories?.map(c => c.id) || [],
                medias: medias,
                brand: productById?.brand?.id || null,
                price: productById?.price || '',
                oldPrice: productById?.oldPrice || '',
                count: productById.count || '',
                bestSeller: !!productById?.bestSeller,
                badges: badges || [],
                isHidden: !!productById?.isHidden,


                attributeValues: productById.attributeValues || [],
                measurementUnit: productById?.measurementUnit || '',
                identicalProducts: identicalProducts,
                isAvailable: productById?.isAvailable,
                isSpecialOffer: productById?.isSpecialOffer,
            }

            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                fieldsData: initStateData,
            });
        }

    }

    checkProductListDifferent(currProducts) {
        let result = false;
        const initProducts = this.currentData.identicalProducts;
        if (!Array.isArray(currProducts) || (currProducts?.length !== initProducts.length)) {
            result = true;
        } else {
            currProducts.forEach((item, index) => {
                if (initProducts[index]?.id !== item?.id) {
                    result = true;
                }
            })
        }
        result ? this.updatedDataMap.set('identicalProducts', currProducts?.map(m => m.id))
            : this.updatedDataMap.delete('identicalProducts');
    }

    checkMediaListDifferent(currMedias) {
        let result = false;
        const initMedias = this.currentData.medias;
        if (!Array.isArray(currMedias) || (currMedias?.length !== initMedias.length)) {
            result = true;
        } else {
            currMedias.forEach((item, index) => {
                if (initMedias[index]?.id !== item?.id) {
                    result = true;
                }
            })
        }
        result ? this.updatedDataMap.set('medias', currMedias?.map(m => m.id))
            : this.updatedDataMap.delete('medias');
    }

    getProducts(productsArray) {
        const {fieldsData, isEditing} = this.state;
        if (isEditing) {
            this.checkProductListDifferent(productsArray)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                identicalProducts: productsArray,
            }
        })
    }

    deleteProduct(id) {
        const {fieldsData, isEditing} = this.state;
        let products = fieldsData.identicalProducts.filter(p => p.id !== id);

        if (isEditing) {
            this.checkProductListDifferent(products)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                identicalProducts: products,
            }
        })
    }

    onProductPositionChange(items) {
        const {fieldsData, isEditing} = this.state;
        const products = items.map(item => item.product);
        if (isEditing) {
            this.checkProductListDifferent(products)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                identicalProducts: products
            }
        })
    }

    onMediaPositionChange(items) {
        const {fieldsData, isEditing} = this.state;
        const medias = items.map(item => item.media);
        if (isEditing) {
            this.checkMediaListDifferent(medias)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                medias: medias
            }
        })
    }

    getMedia(mediaArray) {
        const {fieldsData, isEditing} = this.state;
        if (isEditing) {
            this.checkMediaListDifferent(mediaArray)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                medias: mediaArray,
            },
        })
    }

    deleteMedia(id) {
        const {fieldsData, isEditing} = this.state;
        let medias = fieldsData.medias.filter(m => m.id !== id);

        if (isEditing) {
            this.checkMediaListDifferent(medias)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                medias: medias,
            }
        })
    }

    getMultiSelectData = (checkedKeys, name) => {
        const {fieldsData, isEditing} = this.state;
        if (isEditing) {
            const updatedValues = checkedKeys?.length ? checkedKeys : []
            arraysEquals(this.currentData?.[name], checkedKeys)
                ? this.updatedDataMap.delete(name)
                : this.updatedDataMap.set(name, updatedValues);
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [name]: checkedKeys,
            }
        })
    };

    treeData = (data, children) => {
        const treeData = [];
        data.forEach(item => {
            const treeItem = {
                title: item.title,
                key: item.id,
            };
            if (children && item[children] && item[children]?.length) {
                treeItem.children = this.treeData(item[children], children)
            }
            treeData.push(treeItem);
        })
        return treeData;
    };

    treeAttributesData = (data,) => {
        return data.map(item => {
            return <TreeNode title={item.title} key={item.id}>
                {item?.attributeValues?.length && item.attributeValues.map(attribute => {
                    return <TreeNode title={attribute.title} key={attribute.id}>
                        {attribute?.values?.length && attribute.values.map(value => {
                            return <TreeNode title={value.title} key={value.id}/>
                        })}
                    </TreeNode>
                })}
            </TreeNode>
        })
    };

    getAttributeNewValue = ({value}) => {
        this.setState({
            attributeNewValue: value
        })
    }

    toggleAddAttribute(key = null) {
        this.setState({
            addAttributeKey: key,
            attributeNewValue: ''
        })
    }

    productCardWrapper(data) {
        return <ProductCard data={data?.item?.product}
                            onDelete={this.deleteProduct}
                            viewCard={true}/>
    }

    mediaCardWrapper(data) {
        return <MediaFileCard item={data?.item?.media}
                              customDelete={this.deleteMedia}/>
    }

    async addUpdateProduct() {
        await this.setState({
            requestLoading: true
        });
        const {fieldsData} = this.state;
        const {translations, brand, price} = fieldsData;
        const translationRequiredFields = ['title']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = {...validationTr.errors};

        if (!brand) {
            errors.brand = true;
            result = false;
        }

        // if (!price) {
        //     errors.price = true;
        //     result = false;
        // }
        if (result) {
            if (!this.state.isEditing) {
                const reqData = this.getPostReqData(fieldsData);
                this.props.AddProduct(reqData).finally(() => {
                    this.setState({requestLoading: false})
                })
            } else {
                const trData = getTranslationData(translations);
                const reqData = this.getPatchReqData(trData);
                this.props.UpdateProduct(this.props.id, reqData).finally(() => {
                    this.setState({requestLoading: false});
                });
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    addPartnerItem = () => {
        const { isEditing, } = this.state
        const partners = [{
            partnerId: null,
            link: ''
        },
            ...this.state.fieldsData.partners]
        if (isEditing) {
            this.updatedDataMap.set('partners', partners)
        }
        this.setState({
            fieldsData: {
                ...this.state.fieldsData,
                partners: partners
            }
        })
    }

    getPartnersValue = (index, value, name) => {
        const { fieldsData, isEditing } = this.state;

        const partners = this.state.fieldsData.partners.map((item, pos) => {
            return pos === index ? {
                ...item,
                [name]: value
            } : item
        })
        if (isEditing) {
            this.updatedDataMap.set('partners', partners)
        }
        this.setState({
            fieldsData: {
                ...this.state.fieldsData,
                partners: partners
            }
        })
    }

    deletePartners (index) {
        const { isEditing, fieldsData, errors } = this.state;
        const partners = fieldsData.partners.filter((_, pos) => pos !== index)
        if (isEditing) {
            this.updatedDataMap.set('partners', partners)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                partners: partners
            },
            errors: {
                ...errors,
                partners: {}
            }
        })
    }

    partnersItem = (data) => {
        const { errors } = this.state
        const { partnersList } = this.props
        const partnersOptions = partnersList?.map(partner => {
            return {
                id: partner?.id,
                name: partner?.title || ' '
            }
        });
        const { index, partners } = data.item
        return <div className={'social-item'}>
            <div className={`type-select ${errors?.partners?.[index + 'icon'] ? 'error' : ''}`}>
                <InputGroup inputType="selectCustom"
                            placeholder="Գործընկերներ"
                            label="Գործընկերներ"
                            name="partnerId"
                            showSearch={false}
                            value={partners?.partnerId}
                            onChange={({ value }) => this.getPartnersValue(index, value, 'partnerId')}
                            options={partnersOptions}/>
            </div>
            <InputGroup inputType="input"
                        type="text"
                        label="Հղում"
                        placeholder="Հղում"
                        name="link"
                        value={partners?.link}
                        maxLength={256}
                        error={errors?.partners?.[index + 'link']}
                        onChange={({ value }) => this.getPartnersValue(index, value, 'link')}/>
            <div className={`delete-btn`} onClick={() => this.deletePartners(index)}>
                <MaterialIcon icon="delete"/>
            </div>
        </div>
    }

    getSocialNestableItems = () => {
        const { fieldsData } = this.state
        const { partners } = fieldsData
        const items = [];
        partners && !!partners.length && partners.forEach((item, index) => {
            items.push({
                id: index,
                index: index,
                partners: item
            })
        });
        return items;
    }

    render() {
        const {badgesList, brands, partnersList, filtersList, categoriesList, mainLanguage} = this.props;
        const {
            fieldsData, languageTab, isEditing, loading, errors, mediaModalOpen, attributeNewValue, addAttributeKey,
            productsModalOpen, errorsTabs
        } = this.state;

        const {translations} = fieldsData;
        const trData = translations[languageTab] || {};
        const initTrData = this.currentData?.translations[languageTab] || {};
        const productItems = [];
        const mediaItems = [];

        fieldsData.identicalProducts.forEach(product => {
            productItems.push({
                id: product?.id,
                product: product
            })
        });

        fieldsData.medias.forEach(media => {
            mediaItems.push({
                id: media?.id,
                media: media
            })
        });

        const badgesOptions = badgesList?.map(badge => {
            return {
                key: badge?.id,
                title: badge?.title || ' '
            }
        });


        const brandsOptions = brands?.itemsList?.map(brand => {
            return {
                id: brand?.id,
                title: brand.title || ' '
            }
        });


        let items = this.getSocialNestableItems();

        return <PageWrapper pageTitle={`${!isEditing ? 'Ավելացնել' : trData?.title}`}>
            <section className="product-add-edit">
                <div className="fixed-top-right">
                    <label>{!fieldsData.isHidden ? "Ակտիվ " : "Ոչ ակտիվ"}</label>
                    <Switch checked={!fieldsData.isHidden}
                            onChange={(checked) => this.getInputValues({
                                name: 'isHidden',
                                value: !checked,
                                haveChanges: this.currentData?.isHidden !== !checked
                            })}/>
                </div>
                <div className={'fixed-top-right fixed-stoke'}>
                    <label>
                        Լավագույն վաճառք
                    </label>
                    <Switch checked={!!fieldsData.bestSeller}
                            onChange={(checked) => this.getInputValues({
                                name: 'bestSeller',
                                value: checked,
                                haveChanges: this.currentData?.bestSeller !== checked
                            })}/>
                </div>
                {/*      <div className={'fixed-top-right fixed-stoke'}>
                    <label>
                        {fieldsData.isAvailable ? 'Առկա Է' : 'Առկա Չէ'}
                    </label>
                    <Switch checked={!!fieldsData.isAvailable}
                            onChange={(checked) => this.getInputValues({
                                name: 'isAvailable',
                                value: checked,
                                haveChanges: this.currentData?.isAvailable !== checked //convert to number
                            })}/>
                </div>
                <div className={'fixed-top-right fixed-special'}>
                    <label>
                        {fieldsData.isSpecialOffer ? 'Հատուկ առաջարկ Է' : 'Հատուկ առաջարկ Չէ'}
                    </label>
                    <Switch checked={!!fieldsData.isSpecialOffer}
                            onChange={(checked) => this.getInputValues({
                                name: 'isSpecialOffer',
                                value: checked,
                                haveChanges: this.currentData?.isSpecialOffer !== checked //convert to number
                            })}/>
                </div>
               */}

                <div className={'products-medias-list-wrapper '}>
                    <div className={'label-and-action'}>
                        <label>Նկարներ</label>
                        <LinkButton title="Ընտրել Մեդիադարանից"
                                    className={`media-select-btn `}
                                    cb={this.toggleMediaModal}/>
                    </div>
                    <section className={'items-wrapper media-items'}>
                        {mediaItems.length ? <Nestable
                                items={mediaItems}
                                maxDepth={1}
                                onChange={this.onMediaPositionChange}
                                renderItem={this.mediaCardWrapper}
                            /> :
                            <p className={'empty-text'}>Նկարներ չկան</p>}
                    </section>
                </div>
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              activeTab={languageTab}
                              errorsTabs={errorsTabs}/>
                <div className="product-wrapper">
                    <div className="left-part">
                        <div className="input-form">
                            <InputGroup inputType="input"
                                        type="text"
                                        label={"Անվանում"}
                                        placeholder="Անվանում"
                                        name="title"
                                        value={trData?.title}
                                        required={true}
                                        initValue={initTrData?.title}
                                        error={errors?.['title' + languageTab]}
                                        onChange={this.getTranslatableInputValues}/>
                        </div>
                        <div className="input-form">
                            <InputGroup inputType="selectCustom"
                                        placeholder="Բրենդ"
                                        label="Բրենդ"
                                        name="brand"
                                        showSearch={false}
                                        error={errors?.brand}
                                        value={fieldsData?.brand}
                                        initValue={this.currentData?.price}
                                        onChange={this.getInputValues}
                                        options={brandsOptions}/>
                        </div>


                    </div>
                    <div className="right-part">
                        <InputGroup inputType="input"
                                    type="text"
                                    label={"Ենթաանվանում"}
                                    placeholder="Ենթաանվանում"
                                    name="subTitle"
                                    value={trData?.subTitle}
                                    initValue={initTrData?.subTitle}
                                    error={errors?.['subTitle' + languageTab]}
                                    onChange={this.getTranslatableInputValues}/>
                        {/*<div className="third-wrapper">*/}

                        {/*    <InputGroup inputType="input"*/}
                        {/*                type="text"*/}
                        {/*                number={true}*/}
                        {/*                minValue={1}*/}
                        {/*                maxValue={9999999}*/}
                        {/*                label="Նոր գին"*/}
                        {/*                placeholder="Նոր գին"*/}
                        {/*                name="price"*/}
                        {/*                value={fieldsData?.price}*/}
                        {/*                initValue={this.currentData?.price}*/}
                        {/*                error={errors?.price}*/}
                        {/*                onChange={this.getInputValues}/>*/}
                        {/*    <InputGroup inputType="input"*/}
                        {/*                type="text"*/}
                        {/*                number={true}*/}
                        {/*                label="Հին գին"*/}
                        {/*                minValue={1}*/}
                        {/*                maxValue={9999999}*/}
                        {/*                placeholder="Հին գին"*/}
                        {/*                name="oldPrice"*/}
                        {/*                value={fieldsData?.oldPrice}*/}
                        {/*                initValue={this.currentData?.oldPrice}*/}
                        {/*                onChange={this.getInputValues}/>*/}
                        {/*    <InputGroup inputType="input"*/}
                        {/*                type="text"*/}
                        {/*                integerNumber={true}*/}
                        {/*                minValue={1}*/}
                        {/*                label="Քանակ"*/}
                        {/*                placeholder="Քանակ"*/}
                        {/*                name="count"*/}
                        {/*                value={fieldsData?.count}*/}
                        {/*                initValue={this.currentData?.count}*/}
                        {/*                error={errors?.count}*/}
                        {/*                onChange={this.getInputValues}/>*/}
                        {/*</div>*/}
                        {/*  <div className="quarter-wrapper">
                            <InputGroup inputType="selectCustom"
                                        label={"Չափման միավոր"}
                                        placeholder="Չափման միավոր"
                                        name="measurementUnit"
                                        showSearch={false}
                                        value={fieldsData?.measurementUnit}
                                        initValue={this.currentData?.measurementUnit}
                                        withClear={true}
                                        onChange={this.getInputValues}
                                        options={measurementUnitOptions}/>

                            <InputGroup inputType="selectCustom"
                                        label={"Պիտակ"}
                                        placeholder="Պիտակ"
                                        name="badges"
                                        showSearch={false}
                                        value={fieldsData?.badges}
                                        initValue={this.currentData?.badges}
                                        withClear={true}
                                        onChange={this.getInputValues}
                                        options={badgesOptions}/>

                        </div>*/}
                    </div>
                    <div className="trees-wrapper">
                        <div className="tree-item">
                            <label>Գործընկերներ</label>
                            <div className={'add-row'}>
                                <LinkButton title="Ավելացնել"
                                            className={`media-select-btn`}
                                            cb={this.addPartnerItem}/>
                            </div>
                            {items && items.length !== 0 &&
                                <Nestable
                                    items={items}
                                    maxDepth={1}
                                    onChange={this.onSocialPositionChange}
                                    renderItem={this.partnersItem}
                                />}
                            {/*<Tree*/}
                            {/*    checkable*/}
                            {/*    onCheck={(keys) => this.getMultiSelectData(keys, 'partners')}*/}
                            {/*    checkedKeys={fieldsData.partners}*/}
                            {/*    showLine={true}*/}
                            {/*    treeData={partnersOptions}*/}
                            {/*/>*/}
                        </div>
                        <div className="tree-item">
                            <label>Կատեգորիաներ</label>
                            <Tree
                                checkable
                                onCheck={(keys) => this.getMultiSelectData(keys, 'categories')}
                                checkedKeys={fieldsData.categories}
                                showLine={true}
                                treeData={this.treeData(categoriesList, "subCategories")}
                            />
                        </div>
                        <div className="tree-item">
                            <label>Ֆիլտրեր</label>
                            <Tree
                                checkable
                                checkedKeys={fieldsData.filters}
                                onCheck={(keys) => this.getMultiSelectData(keys, 'filters')}
                                showLine={true}
                                treeData={this.treeData(filtersList, "values")}
                            />
                        </div>
                        {/*
                        <div className="tree-item">
                            <label>Բնութագրեր</label>
                            <Tree
                                checkable
                                checkedKeys={fieldsData.attributeValues}
                                onCheck={(keys) => this.getMultiSelectData(keys, 'attributeValues')}
                                showLine={true}
                                treeData={this.treeData(attributesList, "values")}
                            >
                                {attributesList?.map(item => {
                                    return <TreeNode title={item.title} key={item.id}>
                                        {item?.attributeValues?.length && item.attributeValues.map(attribute => {
                                            return <TreeNode title={
                                                <span className={'add-attribute-toggler-btn'}>
                                                {attribute.title}
                                                    <LinkButton title={<MaterialIcon icon={'add'}/>}
                                                                cb={this.toggleAddAttribute.bind(this, attribute.id)}/>
                                            </span>}
                                                             className={'tree-node-with-toggler'}
                                                             key={attribute.id}>
                                                {addAttributeKey === attribute.id &&
                                                <TreeNode title={<div className={'attribute-inner'}>
                                                    <InputGroup inputType="input"
                                                                type="text"
                                                                placeholder="Անվանում"
                                                                name="title"
                                                                maxLength={100}
                                                                value={attributeNewValue}
                                                                error={errors?.['title' + languageTab]}
                                                                onChange={this.getAttributeNewValue}/>
                                                    <LinkButton title={<MaterialIcon icon={'save'}/>}/>
                                                </div>}
                                                          className={'add-attribute-value-wrapper'}
                                                          key="add-value"
                                                          disableCheckbox/>}
                                                {attribute?.values?.length && attribute.values.map(value => {
                                                    return <TreeNode title={value.title} key={value.id}/>
                                                })}
                                            </TreeNode>
                                        })}
                                    </TreeNode>
                                })}
                            </Tree>
                        </div>*/}
                        {/*<div className="tree-item">*/}
                        {/*    <label>Պիտակներ</label>*/}
                        {/*    <Tree*/}
                        {/*        checkable*/}
                        {/*        checkedKeys={fieldsData.badges}*/}
                        {/*        onCheck={(keys) => this.getMultiSelectData(keys, 'badges')}*/}
                        {/*        showLine={true}*/}
                        {/*        treeData={badgesOptions}*/}
                        {/*    />*/}
                        {/*</div>*/}
                    </div>
                </div>
                <br/>
                <InputGroup inputType="textarea"
                            type="text"
                            label="Ինչպես օգտագործել"
                            placeholder="Ինչպես օգտագործել"
                            name="utilize"
                            value={trData.utilize}
                            initValue={initTrData.utilize}
                            error={errors['utilize' + languageTab]}
                            onChange={this.getTranslatableInputValues}/>
                <div className={'editors'}>
                    <div className={'editor-wrapper'}>
                        <label>Նկարագրություն</label>
                        <Editor value={trData.description || ""}
                                name={'description'}
                                initValue={initTrData.description}
                                error={errors['description' + languageTab]}
                                onChange={this.getTranslatableInputValues}/>
                    </div>
                    <div className={'editor-wrapper'}>
                        <label>Բաղադրիչներ</label>
                        <Editor
                            value={trData?.ingredients || ""}
                            name={'ingredients'}
                            initValue={initTrData?.ingredients}
                            error={errors['ingredients' + languageTab]}
                            onChange={this.getTranslatableInputValues}/>
                    </div>

                </div>
                {/* <section className={'products-medias-list-wrapper'}>
                    <div className={'label-and-action'}>
                        <label>Նմանատիպ Ապրանքներ</label>
                        <LinkButton title="Ընտրել Ապրանքներից"
                                    className={`media-select-btn `}
                                    cb={this.toggleProductsModal}/>
                    </div>
                    <div className={'items-wrapper'}>
                        {productItems.length ? <Nestable
                                items={productItems}
                                maxDepth={1}
                                onChange={this.onProductPositionChange}
                                renderItem={this.productCardWrapper}
                            /> :
                            <p className={'empty-text'}>Կցված ապրանքներ չկան</p>}
                    </div>
                </section>*/}
                <div className="flex-wrapper-right">
                    <LinkButton title={`${isEditing ? 'Փոփոխել' : 'Ավելացնել'}`}
                                loading={loading}
                                disabled={!this.updatedDataMap.size && isEditing}
                                cb={this.addUpdateProduct}/>
                </div>
            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                mediaType={MEDIA_MODAL_TYPES.MEDIA_ARRAY}
                multiSelect={true}
                appendMedias={fieldsData.medias}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
            {/*     <ProductsSelectorModal
                isOpen={!!productsModalOpen}
                getSelectedProducts={this.getProducts}
                appendProducts={fieldsData.identicalProducts}
                disabledProducts={isEditing ? [this.props?.id] : []}
                closeModal={this.toggleProductsModal}
            />*/}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    AddProduct,
    UpdateProduct,
    GetProductById,
    AppendBrand,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditProduct)
